import type { LoginState } from '@mimir/client-common/util/persistentUserSession';
import { GetAuthCookiesCommand } from '@mimir/common/api/authCommands';
import { abortableSleep } from '@mimir/common/async/abortableSleep';
import type { MimirClient } from '@mimir/common/client/mimirClient';
import { watchEffect } from 'vue';

export function stayAuthorizedWhileSignedIn(loginState: LoginState, mimirClient: MimirClient) {
  let ongoingAuthorization: AbortController | null = null;
  watchEffect(() => {
    if (loginState.refreshToken == null) {
      if (ongoingAuthorization != null) {
        ongoingAuthorization.abort();
        ongoingAuthorization = null;
      }
    } else if (ongoingAuthorization == null) {
      ongoingAuthorization = new AbortController();
      stayAuthorized(mimirClient, ongoingAuthorization.signal).catch(console.error);
    }
  });
}

async function stayAuthorized(mimirClient: MimirClient, signal: AbortSignal) {
  while (!signal.aborted) {
    try {
      await mimirClient.send(new GetAuthCookiesCommand({}));
    } catch (ex) {
      console.error('Failed to fetch cookies', ex);
    }

    await abortableSleep(12 * 60 * 60 * 1000, signal).catch(() => {});
  }
}
